var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "40",
          height: "40",
          fill: "none"
        }
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#02016F",
          "fill-rule": "evenodd",
          d:
            "M9.756 0h20.493c3.398 0 4.633.357 5.872 1.02A6.894 6.894 0 0 1 38.98 3.9C39.646 5.145 40 6.374 40 9.771v20.483c0 3.396-.353 4.63-1.02 5.873a6.946 6.946 0 0 1-2.86 2.858C34.883 39.648 33.648 40 30.25 40H9.756c-3.398 0-4.633-.352-5.877-1.015a6.96 6.96 0 0 1-2.86-2.858C.354 34.884 0 33.65 0 30.254V9.77c0-3.396.353-4.625 1.02-5.869A6.909 6.909 0 0 1 3.88 1.02C5.132.357 6.357 0 9.755 0Z",
          "clip-rule": "evenodd"
        }
      }),
      _c("g", { attrs: { "clip-path": "url(#a)" } }, [
        _c("path", {
          attrs: {
            fill: "#fff",
            "fill-rule": "evenodd",
            d:
              "M21.644 19.268a.352.352 0 0 1 .352.352v6.562a.352.352 0 0 1-.352.352h-1.057a.36.36 0 0 1-.352-.352V19.62a.352.352 0 0 1 .352-.352h1.057Zm-3.436 1.915a.395.395 0 0 1 .395.404v4.544a.395.395 0 0 1-.395.403h-.988a.384.384 0 0 1-.395-.403v-4.544a.386.386 0 0 1 .395-.404h.988Zm-3.436 1.95a.378.378 0 0 1 .378.378v2.646a.378.378 0 0 1-.378.377h-.953a.368.368 0 0 1-.37-.377V23.51a.378.378 0 0 1 .37-.378h.953ZM22.666 10a7.662 7.662 0 0 1 7.627 7.687 6.596 6.596 0 0 1-1.838 12.884h-1.022a.361.361 0 0 1-.36-.36v-.97a.37.37 0 0 1 .36-.37h1.03a4.879 4.879 0 0 0 .387-9.723.232.232 0 0 1-.215-.224v-1.237a6.012 6.012 0 0 0-6.012-6.012 5.944 5.944 0 0 0-5.84 4.922l-.044.377a.37.37 0 0 1-.36.318h-2.577a3.762 3.762 0 0 0-3.573 3.677V21.93a.233.233 0 0 1-.232.233 3.298 3.298 0 0 0-3.195 2.886 3.324 3.324 0 0 0 3.118 3.848H21.686a2.267 2.267 0 0 0 1.967-2.26v-8.932a.378.378 0 0 1 .378-.378h.953a.37.37 0 0 1 .37.378v9.113a3.994 3.994 0 0 1-3.436 3.753H10.083a5.05 5.05 0 0 1-1.495-9.852 5.531 5.531 0 0 1 4.93-5.007h1.821A7.619 7.619 0 0 1 22.657 10h.009Z",
            "clip-rule": "evenodd"
          }
        })
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "a" } }, [
          _c("path", { attrs: { fill: "#fff", d: "M5 10h30v20.571H5z" } })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }